<template>
  <div class="table-wrapper-scroll-y app-scroll-table">
    <table class="table table-striped table-bordered table-condensed">
      <thead>
        <tr>
          <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">OS</div></th>
          <th class="col-sm-3 col-md-3 col-lg-3"><div class="text-center">File Name</div></th>
          <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">Size</div></th>
          <th class="col-sm-1 col-md-1 col-lg-1 hidden-tablet"><div class="text-center">Comment</div></th>
          <th class="col-sm-4 col-md-4 col-lg-4 hidden-tablet"><div class="text-center">Uploaded Date</div></th>
          <th class="col-sm-1 col-md-1 col-lg-1"><div class="text-center">Owner</div></th>
          <th class="col-sm-1 col-md-1 col-lg-1 iso-image-actions-col"><div class="text-center">Operation</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in data.rows || []" :key="`iso-${row.id}`">
          <td><div class="text-center"><img :src="row.os_icon_url" width="20" height="20" alt=""></div></td>
          <td>{{ row.filename }}</td>
          <td><div class="text-center">{{ row.size }}</div></td>
          <td class="hidden-tablet">{{ row.comment }}</td>
          <td class="hidden-tablet">{{ row.updated_at }}</td>
          <td><div class="text-center">{{ row.owner }}</div></td>
          <td class="iso-image-actions-col" v-html="row.action_html"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [] })
  }
})

const data = ref(props.initialData || { rows: [] })

watch(
  () => props.initialData,
  (nextValue) => {
    data.value = nextValue || { rows: [] }
  }
)

function handleUpdate(event) {
  data.value = event.detail || { rows: [] }
}

onMounted(() => {
  document.addEventListener('scc:iso-image-results:update', handleUpdate)
})

onBeforeUnmount(() => {
  document.removeEventListener('scc:iso-image-results:update', handleUpdate)
})
</script>
